import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const midnight = new Date();
      midnight.setHours(23, 59, 59, 999);
      const difference = midnight.getTime() - now.getTime();
      if (difference > 0) {
        setTimeLeft({
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      }
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-[#8B0000] text-white py-1.5 px-3 shadow-md" data-id="element-262">
      <div className="max-w-6xl mx-auto flex flex-row items-center justify-center gap-2 text-center text-xs md:text-sm font-medium" data-id="element-263">
        <div className="flex items-center gap-1.5 animate-pulse" data-id="element-264">
          <AlertTriangle size={14} className="text-gold-400 flex-shrink-0" data-id="element-265" />
          <span data-id="element-266">
            <strong className="text-gold-400" data-id="element-267">ATENCIÓN:</strong> El precio
            especial de $6,37 usd termina hoy a las 23:59. Razón: Alta demanda
            de soporte para la Ley de Quiebras.
          </span>
        </div>
        <div className="flex items-center gap-0.5 bg-black/20 px-2 py-0.5 rounded font-mono text-sm font-bold tracking-wider" data-id="element-268">
          <span data-id="element-269">{formatTime(timeLeft.hours)}</span>:
          <span data-id="element-270">{formatTime(timeLeft.minutes)}</span>:
          <span data-id="element-271">{formatTime(timeLeft.seconds)}</span>
        </div>
      </div>
    </div>;
}